module.exports = __webpack_public_path__ + "static/media/customer-solution-1.a586e1cd.png";